import React, { useState, useEffect } from 'react';

const LiveDate = ({ showTime = false, className = '' }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatDate = (d) => d.toLocaleDateString('en-IN', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  });

  const formatTime = (d) => d.toLocaleTimeString('en-IN', {
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });

  return (
    <span className={className}>
      {formatDate(now)}{showTime && ` — ${formatTime(now)}`}
    </span>
  );
};

export default LiveDate;
